export default __webpack_public_path__ + "static/media/neer_logo.22eef43c.svg";